import CoreScroll from '../../mixins/core-scroll'

export default
{
    name: 'app-bg',

    mixins:
    [
        CoreScroll
    ],

    data()
    {
        return {
            items: [],
            transformScrollImg: ''
        }
    },

    created()
    {
        this._scrollY = 0
        this.onScroll(0)
        this.eventHub.$on('bg-change', this._change)
    },

    methods:
    {
        _change(img = null, video = null)
        {
            const lastImg = JSON.parse(JSON.stringify(this.items.filter(d => d.enable)))

            if (lastImg)
            {
                if (lastImg.src === img)
                {
                    return
                }
                else
                {
                    // DELETE LAST IMG
                    const i = this.items.findIndex(d => d.enable)
                    lastImg.enable = false
                    this.items.splice(i, 1, lastImg)
                }
            }

            if (img !== null || video !== null)
            {
                this._addItem(img, video)
            }
        },

        onScroll(y)
        {
            const scrollY = y

            this._scrollY = scrollY
            this.transformScrollImg = 'translateY(' + (scrollY * 0.1).toFixed(2) + 'px) translateZ(0)'
        },

        _addItem(img, video)
        {
            const isVideo = video !== null // (video !== null && !this.$root.isTouch) || (img === null)
            const src = isVideo ? video : img

            const items = JSON.parse(JSON.stringify(this.items))
            const item = items.find(itemData => itemData.src === src)
            const pushItem = () =>
            {
                const itemData = {
                    src,
                    opacity: 1,
                    isVideo,
                    enable: true
                }

                items.push(itemData)
            }


            if (item)
            {
                item.enable = true
            }
            else if (isVideo)
            {
                this._loadVideo(src, pushItem)
            }
            else
            {
                this._loadImg(src, pushItem)
            }

            this.items = items
        },

        _loadImg(src, callback)
        {
            const imgElmt = new Image()
            imgElmt.onload = callback
            imgElmt.src = src
        },

        _loadVideo(src, callback)
        {
            callback()
        }
    }
}



// WEBPACK FOOTER //
// ./src/scripts/components/app-bg/script.js